import { render } from "./ChatContainer.vue?vue&type=template&id=9e1aecce&scoped=true"
import script from "./ChatContainer.vue?vue&type=script&lang=js"
export * from "./ChatContainer.vue?vue&type=script&lang=js"

import "./ChatContainer.vue?vue&type=style&index=0&id=9e1aecce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e1aecce"]])

export default __exports__